import FindInPageIcon from '@mui/icons-material/FindInPage'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import AssignmentIcon from '@mui/icons-material/Assignment'
import HomeIcon from '@mui/icons-material/Home'
import PersonIcon from '@mui/icons-material/Person'
import DescriptionIcon from '@mui/icons-material/Description'
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader as SubText,
  SwipeableDrawer as MuiSwipeableDrawer,
} from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Funcionalidades } from 'utils/helpers/funcionalidades'
import { useAuthContext } from '../../../../contexts/auth.context'

type DrawerMenuProps = {
  open: boolean
  onClose: () => void
}

type MenuOptionsProps = {
  id: number
  text: string
  path: string
  icon: React.ReactNode
  divider: boolean
  role: string
}

const DrawerMenu: React.FC<DrawerMenuProps> = ({ open, onClose }) => {
  const navigate = useNavigate()
  const { handleHasPermission } = useAuthContext()

  let count = 0

  const options: MenuOptionsProps[] = [
    {
      id: count++,
      text: 'Início',
      path: '/',
      icon: <HomeIcon />,
      role: Funcionalidades.integraPolicial.consultar,
      divider: false,
    },
    {
      id: count++,
      text: 'Consultar Processos Pendentes de Oitiva',
      path: '/processos-pendentes',
      icon: <FindInPageIcon />,
      role: Funcionalidades.integraPolicial.consultar,
      divider: false,
    },
    {
      id: count++,
      text: 'Nova Oitiva',
      path: '/nova-oitiva',
      icon: <AddCircleOutlineIcon />,
      role: Funcionalidades.oitiva.cadastrar,
      divider: false,
    },
    {
      id: count++,
      text: 'Consultar Oitiva',
      path: '/consultar-oitiva',
      icon: <AssignmentIcon />,
      role: Funcionalidades.oitiva.consultar,
      divider: false,
    },
    {
      id: count++,
      text: 'Consultar Adolescente',
      path: '/consultar-adolescente',
      icon: <PersonIcon />,
      role: Funcionalidades.fichaAdolescente.consultar,
      divider: false,
    },
    {
      id: count++,
      text: 'Relatório Auditoria',
      path: '/auditoria/ficha-adolescente',
      icon: <DescriptionIcon />,
      role: Funcionalidades.relatorio.auditoria.fichaAdolescente.consultar,
      divider: false,
    },
    {
      id: count++,
      text: 'Gestão de CREAS',
      path: '/creas',
      icon: <DescriptionIcon />,
      role: Funcionalidades.creas.consultar,
      divider: false,
    },
  ]

  const handlePageChange = (path: string): void => navigate(path, { replace: true })

  return (
    <MuiSwipeableDrawer anchor='left' open={open} onClose={onClose} onOpen={onClose}>
      <List subheader={<SubText sx={{ color: 'text.primary' }}>Menu</SubText>}>
        {options
          .filter((item) => handleHasPermission(item.role))
          .map((option) => (
            <ListItem key={option.id} disablePadding onClick={() => handlePageChange(option.path)}>
              <ListItemButton>
                <ListItemIcon>{option.icon}</ListItemIcon>
                <ListItemText primary={option.text} />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </MuiSwipeableDrawer>
  )
}

export default DrawerMenu
